module.exports = __webpack_public_path__ + "static/media/Search.445f2174.png";